const DETAIL_FIELDS = [
  ['cache_tokens', 'Cache R'],
  ['cache_write_tokens', 'Cache W'],
  ['cache_creation_tokens', 'Cache New'],
];

function formatValue(value) {
  if (Array.isArray(value)) {
    return value.join(', ');
  }

  if (typeof value === 'number') {
    return Number.isInteger(value) ? value.toLocaleString('en-US') : String(value);
  }

  return String(value);
}

export function formatLogDetails(other = {}) {
  return DETAIL_FIELDS
    .filter(([key]) => other[key] !== undefined && other[key] !== null && other[key] !== '')
    .map(([key, label, suffix = '']) => ({
      key,
      label,
      value: formatValue(other[key]) + suffix,
    }));
}
